import React from "react";
import { FieldProps } from "@rjsf/utils";
import AlertDest from "./AlertDest";
import { IAlertDestProps } from "./FormGenerator.types";

const withAdditionalProps = (
  Component: React.ComponentType<FieldProps & IAlertDestProps>,
  additionalProps: IAlertDestProps
) => {
  return (props: FieldProps) => <Component {...props} {...additionalProps} />;
};

const AlertDestWithProps = (
  slackChannels: string[],
  telegramChannels: string[],
  smsChannels: string[],
  groupDestinationNames: string[]
) =>
  withAdditionalProps(AlertDest, {
    slackChannels,
    telegramChannels,
    smsChannels,
    groupDestinationNames,
  });

export default AlertDestWithProps;
